<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="documents"
      :items-per-page="10"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="{ 'items-per-page-text': 'Số Hồ Sơ một trang' }"
      v-bind="this.$attrs"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const originHeaders = [
  {
    text: 'Họ tên',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Mã học sinh',
    value: 'code_short',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Phòng thi',
    value: 'rooms',
    align: 'left',
    sortable: false,
    show: true
  }
]

export default {
  props: {
    documents: Array
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },

  methods: {}
}
/* eslint-enable no-unused-vars */
</script>
